module.exports = __webpack_public_path__ + "static/media/HanseMerkur_Extras.1eecce55.png";